(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quiz-segments"]) return;
  try {
    

  // Function to clear local storage variables
  function clearLocalStorage() {
      localStorage.removeItem('name');
      localStorage.removeItem('email');
      localStorage.removeItem('datingStatus');
      localStorage.removeItem('contraception');
      localStorage.removeItem('experience');
      localStorage.removeItem('tryingPregnancy');
      localStorage.removeItem('menopause');
      localStorage.removeItem('quiz-answered');
  }
  
  $(document).ready(function() {

      clearLocalStorage();
    
      // Function to update the visibility of the previous button
      function updatePrevButtonVisibility() {
          if (currentStep === 1) {
              $('#prevBtn').hide(); // Hide the previous button on the first step
              $('.bar-wrap').hide();
          } else {
              $('#prevBtn').show(); // Show the previous button on subsequent steps
              $('.bar-wrap').show(); 
          }
      }
  
      // Hide the previous button initially
      updatePrevButtonVisibility();
  
      $('#continueBtn').click(function() {
          if (currentStep === 1) {
              var name = $('#nameInput').val();
              if (name.trim() === '') {
                  alert('Please enter your name.');
                  return;
              }
              saveAnswer('step1'); // Save the answer for the first question
          } else if (currentStep === 2) {
              var email = $('#emailInput').val();
              if (email.trim() === '' || !isValidEmail(email)) {
                  alert('Please enter a valid email address.');
                  return;
              }
              saveAnswer('step2'); // Save the answer for the second question
          } else if (currentStep === 3) {
              var datingStatus = $('input[name="datingStatus"]:checked').val();
              if (!datingStatus) {
                  alert('Please select your dating status.');
                  return;
              }
              saveAnswer('step3'); // Save the answer for the third question
          } else if (currentStep === 4) {
              var contraception = $('input[name="contraception"]:checked').val();
              if (!contraception) {
                  alert('Please select your contraception method.');
                  return;
              }
              saveAnswer('step4'); // Save the answer for the fourth question
          } else if (currentStep === 5) {
              var experience = [];
              $('input[name="experience"]:checked').each(function() {
                  experience.push($(this).val());
              });
              if (experience.length === 0) {
                  alert('Please select at least one option.');
                  return;
              }
              saveAnswer('step5'); // Save the answer for the fifth question
          } else if (currentStep === 6) {
              var tryingPregnancy = $('input[name="pregnant"]:checked').val();
              if (!tryingPregnancy) {
                  alert('Please select whether you are actively trying to get pregnant.');
                  return;
              }
              saveAnswer('step6'); // Save the answer for the sixth question
          } else if (currentStep === 7) {
              var menopause = $('input[name="menopause"]:checked').val();
              if (!menopause) {
                  alert('Please select your menopause status.');
                  return;
              }
              saveAnswer('step7'); // Save the answer for the seventh question
          }
          nextStep();
          updatePrevButtonVisibility(); // Update visibility after moving to the next step
      });
  
      $('#prevBtn').click(function() {
          prevStep();
          updatePrevButtonVisibility(); // Update visibility after moving to the previous step
      });
  
      $('input[type="radio"]').click(function() {
          // Remove the 'selected-label' class from all labels
          $('.radio-group label').removeClass('selected-label');
          // Add the 'selected-label' class to the label of the selected radio input
          $(this).closest('label').addClass('selected-label');
      });
  });
  
  // Function to save the answer for each question
  function saveAnswer(questionId) {
      var answer;
      switch (questionId) {
          case 'step1':
              answer = $('#nameInput').val().trim();
              localStorage.setItem('name', answer);
              break;
          case 'step2':
              answer = $('#emailInput').val().trim();
              localStorage.setItem('email', answer);
              break;
          case 'step3':
              answer = $('input[name="datingStatus"]:checked').val();
              localStorage.setItem('datingStatus', answer);
              break;
          case 'step4':
              answer = $('input[name="contraception"]:checked').val();
              localStorage.setItem('contraception', answer);
              break;
          case 'step5':
              var experience = [];
              $('input[name="experience"]:checked').each(function() {
                  experience.push($(this).val());
              });
              localStorage.setItem('experience', JSON.stringify(experience));
              break;
          case 'step6':
              answer = $('input[name="pregnant"]:checked').val();
              localStorage.setItem('tryingPregnancy', answer);
              break;
          case 'step7':
              answer = $('input[name="menopause"]:checked').val();
              localStorage.setItem('menopause', answer);
              break;
          default:
              break;
      }
  }
  
  let currentStep = 1;
  const totalSteps = $('.form-step').length;
  
  function nextStep() {
      const current = $('#step' + currentStep);
      const next = $('#step' + (currentStep + 1));
      if (current && next) {
          current.hide();
          if (currentStep === totalSteps - 1) {
              displaySuggestedProducts(); // Display suggested products after the last step
          } else {
              next.show();
              currentStep++;
              updateProgress();
          }
      }
  }
  
  function prevStep() {
      if (currentStep > 1) {
          const current = $('#step' + currentStep);
          const prev = $('#step' + (currentStep - 1));
          if (current && prev) {
              current.hide();
              prev.show();
              currentStep--;
              updateProgress();
          }
      }
  }
  
  function updateProgress() {
      const progress = ((currentStep - 1) / (totalSteps - 1)) * 100;
      $('#progressBar').width(progress + '%');
      $('#progressText').text(progress.toFixed(0) + '%');
  }
  
  function isValidEmail(email) {
      var regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return regex.test(email);
  }
  
  // Function to display suggested products based on survey answers
  function displaySuggestedProducts() {
    var suggestedProductHandles = [];
    var datingStatus = localStorage.getItem('datingStatus');
    var contraception = localStorage.getItem('contraception');
    var experience = JSON.parse(localStorage.getItem('experience')) || [];
    var tryingPregnancy = localStorage.getItem('tryingPregnancy');
    var menopause = localStorage.getItem('menopause');
  
    if (datingStatus === 'Single, not dating') {
        suggestedProductHandles.push('cindy', 'lubricant');
    } else if (datingStatus === 'Casually dating') {
        suggestedProductHandles.push('vegan-natural-condoms', 'lubricant');
    } else if (datingStatus === 'In a relationship') {
        suggestedProductHandles.push('cindy', 'lubricant');
    }
  
    if (contraception === 'Condoms' || contraception === 'The Contraceptive Pill') {
        suggestedProductHandles.push('vegan-natural-condoms');
    }
  
    if (experience.includes('Thrush')) {
        suggestedProductHandles.push('thrush');
    }
    if (experience.includes('Cystitis')) {
        suggestedProductHandles.push('cystitis');
    }
    if (experience.includes('Bacterial Vaginosis')) {
        suggestedProductHandles.push('bacterial-vaginosis');
    }
    if (experience.includes('Low or no libido') || experience.includes('Low mood')) {
        suggestedProductHandles.push('hanx-libido-lift');
    }
    if (experience.includes('Vaginal dryness')) {
        suggestedProductHandles.push('lubricant');
    }
    if (experience.includes('Low energy')) {
        suggestedProductHandles.push('hanx-libido-lift');
    }
  
    if (tryingPregnancy === 'YES') {
        suggestedProductHandles.push('pregnancy-support', 'lubricant', 'test');
    } else if (tryingPregnancy === 'NO') {
        suggestedProductHandles.push('vegan-natural-condoms');
    }
  
    if (menopause === 'YES') {
        suggestedProductHandles.push('menopause-support-1', 'lubricant');
    }
  
  
    // Fetch product information for each handle
    var suggestedProducts = [];
    var requestsCompleted = 0;
  
    suggestedProductHandles.forEach(function(handle) {
        $.ajax({
            url: 'https://www.hanxofficial.com/products/' + handle + '.json',
            type: 'GET',
            dataType: 'json',
            success: function(data) {
                suggestedProducts.push(data.product);
                requestsCompleted++;
  
                // Check if all requests are completed
                if (requestsCompleted === suggestedProductHandles.length) {
                    displaySuggestedProductsHTML(suggestedProducts);
                }
            },
            error: function(xhr, status, error) {
                console.error('Error fetching product with handle ' + handle + ': ' + error);
                requestsCompleted++;
  
                // Check if all requests are completed
                if (requestsCompleted === suggestedProductHandles.length) {
                    displaySuggestedProductsHTML(suggestedProducts);
                }
            }
        });
    });
  
  
    // Additional code
    $(".progress").hide();
    $(".buttons").hide();
    $('#step8').show();
    localStorage.setItem('quiz-answered', 'true');
  }

  
  // Function to display suggested products in HTML
  function displaySuggestedProductsHTML(products) {
    var html = '<div id="suggested-products-wrap">';
    html += '<div class="title-wrap"><h2>Our top suggestions for you</h2></div>';
    html += '<div class="text-wrap"><p>These products have been rated highly by people with a similar health profile and budget to yours, based on data from thousands of individuals.</p></div>';

    if (localStorage.getItem('quiz-answered') === 'true') {
      html += '<div class="discount-code-wrap">Use 3OFF to get 3% off your order!</div>';
    }
    
    html += '<div class="products-inner">';
    
    products.forEach(function(product) {
  
        html += '<div class="suggested-product">';
        
        html += '<div class="image-wrap">';
          // Featured image
          var featuredImage = product.image.src;
          html += '<a href="https://www.hanxofficial.com/products/' + product.handle + '">';
          html += '<img src="' + featuredImage + '" alt="' + product.title + '"></a>';
        html += '</div>';
  
        html += '<div class="info-wrap">';
        html += '<h3 class="title"><a href="https://www.hanxofficial.com/products/' + product.handle + '">' + product.title + '</a></h3>';
        html += '<h4 class="price-wrap">£' + product.variants[0].price + '</h4>';
        html += '<div class="info">' + product.body_html + '</div>';
        
        // Add to cart button
        html += '<button class="customer__button btn large register-btn add-to-cart" data-product-id="' + product.variants[0].id + '">Add to Bag</button>';
        html += '</div>';
        
        html += '</div>'; // End of .suggested-product
        
    });
  
    html += '</div>';
    
    html += '</div>'; // End of #suggested-products-wrap
    $('#suggestedProducts').html(html);

    // Scroll to the suggested products section
    $('html, body').animate({
        scrollTop: $('#suggestedProducts').offset().top
    }, 'slow');
  }
    
    // Add to cart event listener
    $(document).on('click', '.add-to-cart', function() {
        var productId = $(this).data('product-id');
        
        // Add the product to the cart
        $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: {
                quantity: 1,
                id: productId
            },
            success: function(data) {
                // Success callback
                get_cart_details();
                reChargeProcessCart();
    
                // Get the user's name and email from local storage
                var userName = localStorage.getItem('name');
                var userEmail = localStorage.getItem('email');
                
                // Construct the note string with user's name and email
                var nameEmailNote = "User Name: " + userName + "\nUser Email: " + userEmail;
                
                // Remove existing cart notes
                $.ajax({
                    type: 'POST',
                    url: '/cart/update.js',
                    dataType: 'json',
                    data: {
                        note: ''
                    },
                    success: function(data) {
                        console.log('Cart notes cleared:', data);
                        
                        // Update the cart with the new notes
                        $.ajax({
                            type: 'POST',
                            url: '/cart/update.js',
                            dataType: 'json',
                            data: {
                                note: nameEmailNote
                            },
                            success: function(data) {
                                console.log('Note added to cart:', data);
                            },
                            error: function(xhr, status, error) {
                                console.error('Failed to add note to cart:', error);
                            }
                        });
                    },
                    error: function(xhr, status, error) {
                        console.error('Failed to clear cart notes:', error);
                    }
                });
            },
            error: function(xhr, status, error) {
                // Error callback
                console.error('Failed to add product to cart:', error);
            }
        });
    });


  } catch(e) { console.error(e); }
})();
})();
